import { PropsWithChildren } from 'react';

import { TextOld } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

import { StyledContainer, StyledLine } from './styled';

type DividerTextProps = PropsWithChildren<{
  className?: string;
}>;

export const DividerText = ({ children, className }: DividerTextProps) => {
  return (
    <StyledContainer className={className}>
      <StyledLine />
      <TextOld color={COLORS.grey400}>{children}</TextOld>
      <StyledLine />
    </StyledContainer>
  );
};
